import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './utils/auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import TaskList from './components/TaskList';
import TaskDetail from './components/TaskDetail';
import WorkflowHistory from './components/WorkflowHistory';
import DashboardBIAT from './components/DashboardBIAT';
import DocumentSorting from './pages/DocumentSorting';

// Composant pour protéger les routes
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="tasks" element={<TaskList />} />
          <Route path="task/:taskId" element={<TaskDetail />} />
          <Route path="history" element={<WorkflowHistory />} />
          <Route path="dashboard" element={<DashboardBIAT />} />
          <Route path="documents" element={<DocumentSorting />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;

